import React from "react";
import Modal from "react-responsive-modal";
import { Button } from "../../../revvComponents";

import { IMAGE_URLS } from "../../../constants";
import LZLoader from "../../../commonComponents/LZLoader";

const { RECIPIENT_SUBMIT, RECIPIENT_DECLINE } = IMAGE_URLS;

const COPY = {
  submit: {
    imageSrc: RECIPIENT_SUBMIT,
    title: "You are about to submit this document",
    infoFirst: "After you ",
    highlight: "submit,",
    infoSecond: {
      ESIGN:
        " you will receive an email with a link to eSign the document. If there are no other fillers, you'll be redirected to the signing page immediately.",
      ACCEPTANCE:
        "you will receive an email with link to accept the document. If there are no other fillers, you'll be redirected to acceptance page immediately.",
    },
    cancelBtnText: "Cancel",
    proceedBtnText: {
      ESIGN: "Submit document",
      ACCEPTANCE: "Submit",
    },
    btnClass: "revv-btn-primary",
  },
  decline: {
    imageSrc: RECIPIENT_DECLINE,
    title: "You are about to decline this document",
    infoFirst: "Are you sure you want to decline this document?",
    highlight: "",
    infoSecond: "",
    cancelBtnText: "Cancel",
    proceedBtnText: {
      ESIGN: "Decline document",
      ACCEPTANCE: "Decline document",
    },
    btnClass: "reject-document",
  },
};

const RecipientSubmitDeclinePopup = ({
  onConfirm,
  onClose,
  isLoading,
  view,
  docFlow,
}) => {
  const copyText = COPY[view];
  return (
    <Modal
      classNames={{
        modal: "recipientdocinfopopup-modal",
        closeButton: "modal-close-btn-mobile-view",
      }}
      open
      onClose={onClose}
      center
      closeOnOverlayClick={false}>
      {isLoading && (
        <LZLoader
          className="loader-bg-color recipient-loader recipient-submit-loader"
          label={` ${
            isLoading
              ? "🔏 Processing your document for eSignature."
              : "Loading..."
          }`}
        />
      )}
      <div className="recipientdocinfopopup-container">
        {/* ------ Recipient document info header(gif, recipient title and send info) section ------ */}
        <div className="recipientdocinfopopup-header  recipient-white-bg">
          <div className="recipientdocinfopopup-img-wrapper">
            <img
              src={copyText.imageSrc}
              alt="form-mode-check"
              className="recipientdocinfopopup-img"
            />
          </div>
          <div className="recipientdocinfopopup-recipient-title">
            {copyText.title}
          </div>
          <div className="recipientdocinfopopup-sender-info unfilled-info">
            {copyText.infoFirst}
            <strong>
              <i>{copyText.highlight}</i>
            </strong>

            {copyText.infoSecond[docFlow]}
          </div>
        </div>

        <div className="unfilled-form-popup-footer">
          <Button
            data-test="back-to-document-button"
            className="unfilled-form-popup-btn-inherit"
            onClick={onClose}
            onKeyPress={() => {}}>
            {copyText.cancelBtnText}
          </Button>
          <Button
            type="four"
            data-test="submit-anyway-button"
            className={copyText.btnClass}
            onClick={onConfirm}
            onKeyPress={() => {}}>
            {copyText.proceedBtnText[docFlow]}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default RecipientSubmitDeclinePopup;
